import { CollectionApi } from '@linktivity/ars-neo';
import config from './config';

const collectionApi = new CollectionApi(config);

export default collectionApi;
